import Home from './Home'
import JiaMengCustomer from './JiaMengCustomer'
import Goods from './Goods'
import Marketing from './Marketing'
import Schedule from './Schedule'
import Stats from './Stats'
import Order from './Order'
import Setting from './Setting'
import Shop from './Shop'
import Cooperation from './Cooperation'
import { isExperienceStore } from '@util'

export default () => {
  if (isExperienceStore()) {
    return [
      Home,
      Shop,
      Goods,
      // JiaMengCustomer,
      Order,
      Cooperation,
      Marketing,
      // Schedule,
      // Stats,
      Setting
    ]
  } else {
    return [
      Home,
      Shop,
      Goods,
      JiaMengCustomer,
      Order,
      Marketing,
      Schedule,
      Stats,
      Setting
    ]
  }
}
